import { render, staticRenderFns } from "./VeJwPyfaList.vue?vue&type=template&id=de8cc54c&scoped=true"
import script from "./VeJwPyfaList.vue?vue&type=script&lang=js"
export * from "./VeJwPyfaList.vue?vue&type=script&lang=js"
import style0 from "./VeJwPyfaList.vue?vue&type=style&index=0&id=de8cc54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8cc54c",
  null
  
)

export default component.exports